import { OnboardingData } from "../types/onboarding";

const STORAGE_KEY = "onboarding_data";

/**
 * Save onboarding data to localStorage
 */
export const saveOnboardingData = (data: OnboardingData): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Failed to save onboarding data", error);
  }
};

/**
 * Load onboarding data from localStorage
 */
export const loadOnboardingData = (): OnboardingData | undefined => {
  try {
    const json = localStorage.getItem(STORAGE_KEY);
    if (!json) return undefined;
    return JSON.parse(json) as OnboardingData;
  } catch (error) {
    console.error("Failed to load onboarding data", error);
    return undefined;
  }
};

/**
 * Clear onboarding data from localStorage
 */
export const clearOnboardingData = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear onboarding data", error);
  }
};
